import { MessageSquare, History } from 'lucide-react'
import { MockShell } from './MockShell'

export function CommentsMock() {
  return (
    <MockShell title="Baha Q-2417 · Gapdal panel">
      <div className="p-5">
        {/* Tab strip */}
        <div className="flex items-center gap-1 border-b border-border mb-4">
          <button className="px-3 py-2 text-[12px] font-medium -mb-px border-b-2 border-primary text-foreground inline-flex items-center gap-1.5">
            <MessageSquare className="w-3 h-3" /> Teswirler
            <span className="ml-1 text-[10px] font-semibold text-primary">3</span>
          </button>
          <button className="px-3 py-2 text-[12px] font-medium -mb-px border-b-2 border-transparent text-muted-foreground inline-flex items-center gap-1.5">
            <History className="w-3 h-3" /> Hereket
          </button>
        </div>

        {/* Comments */}
        <ul className="space-y-3">
          {[
            { u: 'M', name: 'Mira', t: '2 sag öň', body: 'Eger ýüklemek sş 09:00-a süýşse, Göni henizem ýarar. Bazadakylar bilen tassyklaryn.' },
            { u: 'I', name: 'Ikay', t: '1 sag öň', body: 'Marjany 22%-e çykardym — ýangyç goşmaçasy öňki teklibi iýdi.' },
            { u: 'A', name: 'Acme · Jan', t: '12 mn öň', body: 'Göni bilen geçýäs. Ýüklemek dş 06:00 tassyklandy.', client: true },
          ].map((c) => (
            <li key={c.name} className="flex items-start gap-2.5">
              <div
                className={
                  'w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold shrink-0 ' +
                  (c.client
                    ? 'bg-positive/15 text-positive'
                    : 'bg-primary/10 text-primary')
                }
              >
                {c.u}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[12px] font-semibold">{c.name}</span>
                  {c.client && (
                    <span className="text-[9.5px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded bg-positive/15 text-positive">
                      Müşderi
                    </span>
                  )}
                  <span className="text-[10.5px] text-muted-foreground">{c.t}</span>
                </div>
                <p className="text-[12.5px] text-foreground/90 leading-relaxed">{c.body}</p>
              </div>
            </li>
          ))}
        </ul>

        {/* Composer */}
        <div className="mt-5 rounded-xl border border-border bg-muted/30 p-3">
          <p className="text-[12px] text-muted-foreground">Teswir ýaz…</p>
          <div className="mt-3 flex items-center justify-end">
            <button className="text-[11px] font-medium px-3 py-1.5 rounded-md bg-primary text-primary-foreground">
              Iber
            </button>
          </div>
        </div>
      </div>
    </MockShell>
  )
}
